<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-text"/>
          Bestehenden Hersteller ändern
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="updateHersteller()">
              <HerstellerText v-model="herstellernr" formLabel="Hersteller Nummer" rules=""/>
              <HerstellerText v-model="hersteller" formLabel="Name"/>
              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Hersteller ändern</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import HerstellerText from '@/components/FormElements/Text'

export default {
  name: 'HerstellerEdit',
  components: {
    FormError,
    HerstellerText
  },
  props: {
    uuid: [Number, String]
  },
  data () {
    return {
      herstellernr: '',
      hersteller: '',
      formError: null
    }
  },
  mounted () {
    if (this.uuid) {
      Vue.axios.get('/hersteller/get/' + this.uuid)
        .then((response) => {
          this.herstellernr = response.data.herstellernr || ''
          this.hersteller = response.data.hersteller || ''
        })
    }
  },
  methods: {
    updateHersteller () {
      Vue.axios.put('/hersteller/put/' + this.uuid, {
        herstellernr: this.herstellernr && this.herstellernr.trim() !== '' ? this.herstellernr.trim() : null,
        hersteller: this.hersteller ? this.hersteller.trim() : ''
      }).then((response) => {
        this.$router.push({ path: '/hersteller/uebersicht' })
        this.$snotify.success('Der Hersteller wurde angepasst.', {
          position: 'rightTop',
          timeout: 4000
        })
      }).catch((error) => {
        this.formError = error.response.data
      })
    }
  }
}
</script>
